import { GlobalBus } from '@services/bus'
import { RELOAD } from '@constants/Text'

const ADD_AREAS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    if (payload.length === 1) {
      payload.forEach((area) => {
        const old = state.areas.data.find((a) => a.id === area.id)

        if (old) {
          Object.assign(old, area)
        } else {
          state.areas.data.push(area)
        }
      })
    } else {
      state.areas.data = payload || []
    }

    state.areas.lastUpdate = new Date()
  }
}

const SET_AREAS_LOADING = (state, payload) => {
  state.areas.loading = payload
}

const SET_METRICS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    if (payload.length === 1) {
      payload.forEach((metric) => {
        const old = state.metrics.data.find((m) => m.id === metric.id)

        if (old) {
          Object.assign(old, metric)
        } else {
          state.metrics.data.push(metric)
        }
      })
    } else {
      state.metrics.data = payload || []
    }
    state.metrics.lastUpdate = new Date()
  }
}

export const REMOVE_METRIC = (state, payload) => {
  if (payload && typeof payload === 'number') {
    state.metrics.data = state.metrics.data.filter((item) => {
      return item.id !== payload
    })
  }
}

const SET_METRICS_LOADING = (state, payload) => {
  state.metrics.loading = payload
}

const SET_CATEGORIES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    if (payload.length === 1) {
      payload.forEach((category) => {
        const old = state.categories.data.find((c) => c.id === category.id)

        if (old) {
          Object.assign(old, category)
        } else {
          state.categories.data.push(category)
        }
      })
    } else {
      state.categories.data = payload || []
    }
    state.categories.lastUpdate = new Date()
  }
}

const SET_CATEGORIES_LOADING = (state, payload) => {
  state.categories.loading = payload
}

const SET_RUBRICS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.rubrics.data = payload
    state.rubrics.lastUpdate = new Date()
  }
}
const SET_RUBRICS_LOADING = (state, payload) => {
  state.rubrics.loading = payload
}

const SET_METRICS_PJ = (state, payload) => {
  if (payload && typeof payload === 'object') {
    const { id, value } = payload
    if (!state.metricsPJ.data[id]) {
      state.metricsPJ.data[id] = {}
    }
    state.metricsPJ.data[id].data = value
    state.metricsPJ.data[id].lastUpdate = new Date()

    GlobalBus.$emit(RELOAD.FINANCIAL_METRICS_PJ)
  }
}

const SET_METRICS_PJ_LOADING = (state, payload) => {
  const { id, loading } = payload
  if (!state.metricsPJ.data[id]) {
    state.metricsPJ.data[id] = {}
  }
  state.metricsPJ.data[id].loading = loading
}

const SET_METRICS_AREA = (state, payload) => {
  if (payload && typeof payload === 'object') {
    const { id, value } = payload
    state.metricsArea.data[id].data = value
    state.metricsArea.data[id].lastUpdate = new Date()

    // Garantir que vai atualizar os lugares que usam o dado, caso existam.
    GlobalBus.$emit(RELOAD.FINANCIAL_METRICS_AREAS)
  }
}

const SET_METRICS_AREA_LOADING = (state, payload) => {
  const { id, loading } = payload
  if (!state.metricsArea.data[id]) {
    state.metricsArea.data[id] = {}
  }
  state.metricsArea.data[id].loading = loading
}

export const SET_METRICS_FILIAL = (state, payload) => {
  if (payload && typeof payload === 'object') {
    const { id, value } = payload
    if (!state.metricsFilial.data[id]) {
      state.metricsFilial.data[id] = {}
    }
    state.metricsFilial.data[id].data = value
    state.metricsFilial.data[id].lastUpdate = new Date()

    GlobalBus.$emit(RELOAD.FINANCIAL_METRICS_FILIAL)
  }
}

export const SET_METRICS_FILIAL_LOADING = (state, payload) => {
  const { id, loading } = payload
  if (!state.metricsFilial.data[id]) {
    state.metricsFilial.data[id] = {}
  }
  state.metricsFilial.data[id].loading = loading
}

const SET_DRE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.dre.data = { ...payload }
    state.dre.lastUpdate = new Date()
  }
}

const SET_DRE_LOADING = (state, payload) => {
  state.dre.loading = payload
}

export const SET_VALUATION_OFFICE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.valuationOffice.data = payload
    state.valuationOffice.lastUpdate = new Date()
  }
}

export const SET_VALUATION_OFFICE_LOADING = (state, payload) => {
  state.valuationOffice.loading = payload
}

export const SET_VALUATION_PROFESSIONAL = (state, payload) => {
  if (payload && typeof payload === 'object') {
    const { dados, id_profissional } = payload
    state.valuationProfessional.data = {
      ...state.valuationProfessional.data,
      [id_profissional]: dados,
    }
    state.valuationProfessional.lastUpdate = new Date()
  }
}

export const SET_VALUATION_PROFESSIONAL_LOADING = (state, payload) => {
  state.valuationProfessional.loading = payload
}

export const SET_MARGIN = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.margin.data = payload
    state.margin.lastUpdate = new Date()
  }
}

export const SET_MARGIN_LOADING = (state, payload) => {
  state.margin.loading = payload
}

export const SET_SHOW_CATEGORY = (state, payload) => {
  state.batchCategories.show = payload
}

export const SET_QUANTITY_CATEGORY = (state, payload) => {
  state.batchCategories.quantity = payload
}

export const SET_DATA_CATEGORY = (state, payload) => {
  state.batchCategories.categories_ids = payload
}

export const SET_OPTIONS_EDIT_CATEGORY = (state, payload) => {
  state.batchCategories.optionsEdit = payload
}

export {
  ADD_AREAS,
  SET_AREAS_LOADING,
  SET_METRICS,
  SET_METRICS_LOADING,
  SET_CATEGORIES,
  SET_CATEGORIES_LOADING,
  SET_RUBRICS,
  SET_RUBRICS_LOADING,
  SET_METRICS_PJ,
  SET_METRICS_PJ_LOADING,
  SET_METRICS_AREA,
  SET_METRICS_AREA_LOADING,
  SET_DRE,
  SET_DRE_LOADING,
}
